'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _func_1 = require("./_func");
var OrderCart;
(function (OrderCart) {
    var MyOrderCart = /** @class */ (function () {
        function MyOrderCart(ajaxing, headerHeight, totalPosition) {
            var _this = this;
            if (ajaxing === void 0) { ajaxing = false; }
            if (headerHeight === void 0) { headerHeight = 0; }
            if (totalPosition === void 0) { totalPosition = 0; }
            this.ajaxing = ajaxing;
            this.headerHeight = headerHeight;
            this.totalPosition = totalPosition;
            var self = this;
            // カート表示切り替え
            $('.trigViewCart').click(function () {
                var view = $(this).data('view');
                $('.trigViewCart').attr('data-active', 0);
                $('.trigViewCart[data-view="' + view + '"]').attr('data-active', 1);
                $('.bulletViewCart').hide();
                $('.bulletViewCart[data-view="' + view + '"]').show();
            });
            // 数量ボタン操作
            $('.trigChangeQuantity').click(function () {
                var order = $(this).data('order');
                var vector = $(this).data('vector');
                var id = $(this).data('id');
                var quantity = Number($('.bulletChangeQuantity[data-id="' + id + '"]').val());
                self.refreshCart(quantity, vector, order, id);
            });
            $(window).ready(function () {
                // 注文選択ページ
                if ($('#paramThisIsOrderCartPage').val() == "1") {
                    // イメージエリアの初期位置を取得
                    _this.totalPosition = $('.bulletTotalArea').offset().top;
                }
            });
            // セパイメージ図セクションまでスクロールしたら fixed になる
            if ($('#paramThisIsOrderCartPage').val() == "1") {
                $(window).scroll(function () {
                    // スクロールイベント
                    var sc = $(window).scrollTop();
                    if (sc > _this.totalPosition - _this.headerHeight) {
                        var bulletTotalArea = $('.bulletTotalArea');
                        bulletTotalArea.css({ position: 'fixed', top: _this.headerHeight, left: 0, width: '100%', borderBottomColor: '#eee', zIndex: 1000 });
                        $('.bulletViews').css({ paddingTop: bulletTotalArea.outerHeight() });
                        // $('.bulletImageTitle').slideDown();
                    }
                    else {
                        $('.bulletTotalArea').css({ position: 'static', top: false, left: false, width: 'auto', borderBottomColor: '#fff' });
                        $('.bulletViews').css({ paddingTop: 0 });
                        // $('.bulletImageTitle').hide();
                    }
                });
            }
        }
        MyOrderCart.prototype.refreshCart = function (quantity, vector, order, id) {
            var newQuantity = this.getChangedQuantity(quantity, vector);
            this.ajaxRefreshCart(newQuantity, order, id);
            // this.changeQuantity(quantity, vector, separatorId);
            // this.changeSubTotal(separatorId);
            // this.changeTotal();
        };
        MyOrderCart.prototype.getChangedQuantity = function (quantity, vector) {
            if (vector == 'minus') {
                quantity--;
                if (quantity < 1) {
                    quantity = 1;
                }
            }
            else if (vector == 'plus') {
                quantity++;
                if (quantity > 9999) {
                    quantity = 9999;
                }
            }
            return quantity;
        };
        MyOrderCart.prototype.changeQuantity = function (quantity, id) {
            $('.bulletChangeQuantity[data-id="' + id + '"]').val(quantity);
            $('.bulletChangeQuantityString[data-id="' + id + '"]').html(quantity);
        };
        MyOrderCart.prototype.changeSubTotal = function (subtotal, unitPrice, id) {
            $('.bulletChangeSubTotal[data-id="' + id + '"]').html(_func_1.default.numberFormat(_func_1.default.getTaxIn(subtotal, 10)));
            // $('.bulletChangeUnitPrice[data-id="' + id + '"]').html(unitPrice);
        };
        MyOrderCart.prototype.changeTotal = function (total) {
            $('.bulletChangeTotal').html(_func_1.default.numberFormat(_func_1.default.getTaxIn(total, 10)));
        };
        MyOrderCart.prototype.ajaxRefreshCart = function (newQuantity, order, id) {
            var self = this;
            self.ajaxing = true;
            var token = $('meta[name="csrf-token"]').attr('content');
            var D = { new_quantity: newQuantity, order: order, id: id };
            $.ajax({
                headers: { 'X-CSRF-TOKEN': token },
                url: '/ajax/refresh_cart',
                type: 'post',
                data: D,
                dataType: 'json',
                beforeSend: function () {
                    // 実行中画面
                    $('#bulletAjaxingEditting').show();
                },
                success: function (data) {
                    // console.log(data);
                    self.changeQuantity(data.quantity, data.id);
                    self.changeSubTotal(data.subtotal, data.unitPrice, data.id);
                    self.changeTotal(data.total);
                },
                complete: function () {
                    // 実行中画面を消す
                    $('#bulletAjaxingEditting').hide();
                    self.ajaxing = false;
                }
            });
        };
        return MyOrderCart;
    }());
    OrderCart.MyOrderCart = MyOrderCart;
})(OrderCart || (OrderCart = {}));
exports.default = OrderCart;
